module.exports = __webpack_public_path__ + "static/media/cicero_soares_da_silva.22b2281d.jpg";